<template>
  <div class="pullOut">
    <new-task-modal
      class="output-modal"
      :newModalVisible="outputModal"
      @closeNewTask="closeOutPut"
      :isDisabled="total == 0"
      @addNewTask="isNoFoundUser"
      agreeBtn="导出"
      modalTitle="导出照片"
    >
      <div slot="content" style="text-align: left">
        <el-form
          :model="ruleFormOutPut"
          :rules="rulesOutPut"
          ref="ruleFormOut"
          label-width="86px"
          :show-message="false"
          :validate-on-rule-change="false"
          @validate="validateValue"
        >
          <el-form-item label="文件名称" prop="jbDesc">
            <el-input
              class="output-input"
              :maxlength="30"
              placeholder="请输入"
              v-model.trim="ruleFormOutPut.jbDesc"
            ></el-input>
          </el-form-item>
          <el-form-item label="数据范围">
            <el-radio-group v-model="dataRange" @change="chickRadio(dataRange)">
              <el-radio :label="1">全部数据</el-radio>
              <el-radio :label="2">当前检索条件下的数据</el-radio>
              <el-radio :label="3">勾选数据</el-radio>
            </el-radio-group>
            <div class="output-notice" style="padding-top: 0px">
              共计{{ total }}条数据
            </div>
          </el-form-item>
          <el-form-item label="照片命名规则">
            <el-radio-group
              v-model="namingRule"
              v-if="identity == 'NEW_STUDENT'"
            >
              <el-radio :label="1">考生号</el-radio>
              <el-radio :label="2">学号</el-radio>
              <el-radio :label="3">证件号码</el-radio>
            </el-radio-group>
            <el-radio-group v-model="namingRule" v-if="identity == 'STUDENT'">
              <el-radio :label="2">学号</el-radio>
              <el-radio :label="3">证件号码</el-radio>
            </el-radio-group>
            <el-radio-group
              v-model="namingRule"
              v-if="identity == 'GRADUATE_STUDENT'"
            >
              <el-radio :label="2">学号</el-radio>
              <el-radio :label="3">证件号码</el-radio>
            </el-radio-group>
            <el-radio-group v-model="namingRule" v-if="identity == 'TEACHER'">
              <el-radio :label="2">工号</el-radio>
              <el-radio :label="3">证件号码</el-radio>
            </el-radio-group>
            <el-radio-group v-model="namingRule" v-if="identity == 'OTHER'">
              <el-radio :label="2">账号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="照片格式">
            <el-radio-group v-model="formatRule">
              <el-radio :label="1">.jpg</el-radio>
              <el-radio :label="2">.jpeg</el-radio>
              <el-radio :label="3">.png</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="output-notice">
            提示：导出数据请控制在<span style="color: rgb(255, 77, 79)"
              >5000</span
            >条数据以内，否则可能会出现导出失败或系统卡顿
          </div>
        </el-form>
      </div>
    </new-task-modal>
    <new-task-modal
      :showModalClose="false"
      class="output-modal"
      :closeonclickmodal="closeonclickmodal"
      :newModalVisible="daochuGuoCModal"
      @addNewTask="isdaochuGuoC"
      @closeNewTask="isdaochuGuoC"
      :isOneBtn="OnlyBtn"
      :isDisabled="guanbiDisabled"
      agreeBtn="关闭"
      :modalTitle="daochuTitle"
    >
      <div slot="content" style="text-align: left">
        <div class="daoru-addnew">
          <span>耗时 :</span>
          <span>{{ DaochuSuccese.Time }}</span>
          <span v-if="DaochuSuccese.tryMathRemainTime"
            >剩余时间:{{ DaochuSuccese.tryMathRemainTime }}</span
          >
          <span
            v-if="downloadUrl"
            style="color: #2d8cf0; cursor: pointer"
            @click="downloadFile(downloadUrl)"
            >点击下载</span
          >
        </div>
        <div class="daoru-addnew" v-if="!DaochuSuccese.finished">
          <span style="color: #ff4d4f"
            >正在操作，请耐心等待，若操作意外中断，数据仍将继续导出。</span
          >
        </div>
        <!--  -->
        <div
          class="daoru-addnew"
          v-if="DaochuSuccese.finished && DaochuSuccese.errorMsg"
        >
          <!-- <el-tooltip popper-class='tooltip' class="item" :content="DaochuSuccese.errorMsg" placement="top"> -->
          <div @click="open(DaochuSuccese.errorMsg)" class="errorMsg">
            {{ DaochuSuccese.errorMsg }}
          </div>
          <!-- </el-tooltip> -->
        </div>
        <div class="daoru-addnew daoru-progress">
          <el-progress :percentage="percenNum"></el-progress>
        </div>
        <div class="daoru-caozuoshuju">
          <span v-if="DaochuSuccese.totalNum >= 0">{{
            DaochuSuccese.finishNum + "/" + DaochuSuccese.totalNum
          }}</span>
          <span v-if="DaochuSuccese.redisKey">{{
            "导出编号:" + DaochuSuccese.redisKey
          }}</span>
        </div>
      </div>
    </new-task-modal>
    <noticeModalForPullOutZip
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      @downExcel="downExcel"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :noticeContent="noitceContent"
      :choiceNameRule="choiceNameRule"
      :identity="yHu"
      :loading="loading"
    ></noticeModalForPullOutZip>
  </div>
</template>

<script>
import {
  daochuSelectBT,
  daochuSelectBTPost,
  toDaoRuData,
} from "@/api/Daoru/daoru";
import { mapState } from "vuex";
import noticeModalForPullOutZip from './noticeModalForPullOutZip.vue'
export default {
  components: {
    noticeModalForPullOutZip,
  },
  props: {
    // 导出弹窗
    outputModal: {
      type: Boolean,
      default: false,
    },
    //导出勾选数据
    identity: {
      type: String,
      default: "NEW_STUDENT",
    },
    // 检索条件
    formInline: {
      type: Object,
      default: null,
    },
    //导出勾选数据
    checkID: {
      type: String,
      default: "",
    },
    //导出文件列表数据名称
    LBName: {
      type: String,
    },
    // 导出类型
    pullType: {
      type: Object,
      default: null,
    },
    //获取导出总条数接口
    ExportCountURL: {
      type: String,
    },
    //获取导出总条数接口
    lunxun: {
      type: String,
    },
    //导出接口链接
    daochuURL: {
      type: String,
    },
  },
  data() {
    return {
      downloadUrl: "", //下载地址
      isTS: "导出未完成", //导出弹框提示文字
      daochuTitle: "导出", //导出过程定时器
      daochuTimer: null, //导出过程定时器
      IsDaochuTimes: 0, //导出过程定时器
      percenNum: 0, //进度条进度数字
      DaochuSuccese: {
        errorData: [], //错误数据  暂存前端 下载错误数据时返回
        finished: false, // 是否完成导出
        Time: "导出中", //耗时
        totalNum: 0, // 总计需要操作次数
        finishNum: 0, // 当前操作次数
        jumpNum: 0, // 跳过数量
        errorKey: "", //错误数据
      }, //导出成功后的数据列表
      guanbiDisabled: true, //导出过程弹框关闭按钮
      OnlyBtn: true, //导出过程弹框只有一个按钮
      daochuGuoCModal: false, //导出过程弹窗
      closeonclickmodal: false, //是否开启点击空白处关闭弹窗
      isIndeterminate: false,
      //导出表单绑定
      ruleFormOutPut: {
        checkAll: true, // 全选
        // checkAll: false, // 全选
        jbDesc: "",
        gzRadio: 1, // 数据范围
        fieldGroup: [], // 表头字段
      },
      //导出表单验证
      rulesOutPut: {
        jbDesc: [
          { required: true, message: "请输入文件名称", trigger: "blur" },
        ],
        fieldGroup: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个导出字段",
            trigger: "change",
          },
        ],
      },
      //
      total: "", //导出总条数
      countNum: 1, //用于显示第一个错误
      redisKey: "", //用于显示第一个错误
      //=========新增
      dataRange: 1,
      namingRule: 1,
      formatRule: 1,
      //   &********弹框******************************
      //   agreeNotice: {},
      noticeType: 1, // 提示类型
      agreeContent: "确定", // 提示弹窗确认按钮内容
      noticeTitle: "提示", // 提示
      noitceContent: "确定启用删除吗？", // 提示信息
      noticeSpec: "删除后不可恢复，", // 标红提示
      noticeModal: false, // 提示弹窗
      //===================转化使用角色
      loading: false,
    };
  },
  watch: {
    outputModal: function () {
      // let qx = true;
      if (this.outputModal) {
        this.setName();
        this.selectTotal();
        switch (this.identity) {
          case "NEW_STUDENT":
            this.namingRule = 3;
            break;
          case "STUDENT":
            this.namingRule = 3;
            break;
          case "GRADUATE_STUDENT":
            this.namingRule = 3;
            break;
          case "TEACHER":
            this.namingRule = 3;
            break;
          case "OTHER":
            this.namingRule = 2;
            break;
          default:
        }
      }
    },
  },
  methods: {
    open(txt) {
      this.$alert(txt, "错误信息", {
        confirmButtonText: "关闭",
        customClass: "msgCard",
        callback: () => {},
      });
    },
    //关闭导出过程弹框
    isdaochuGuoC() {
      console.log(1111111);
      (this.dataRange = 1),
        (this.namingRule = 1),
        (this.formatRule = 1),
        clearInterval(this.daochuTimer);
      this.daochuTimer = null;
      this.$refs.ruleFormOut.resetFields();
      this.fieldArr = [];
      this.downloadUrl = "";
      this.DaochuSuccese = {
        errorData: [], //错误数据  暂存前端 下载错误数据时返回
        Time: "导出中", //耗时
      };
      this.percenNum = 0;
      this.daochuGuoCModal = false;
      this.guanbiDisabled = true;
      this.$emit("daoruSuccess");
    },
    //给文件名默认值
    setName() {
      let date = new Date();
      let Y = date.getFullYear();
      let IsY = Y.toString();
      console.log("YYYYYY", Y);
      let M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let IsM = M.toString();
      let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let IsD = D.toString();
      let hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let Ishh = hh.toString();
      let mm =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let Ismm = mm.toString();
      let ss =
        date.getSeconds() < 10 ? "0" + date.getDate() : date.getSeconds();
      let Isss = ss.toString();
      let nowData = IsY + IsM + IsD + Ishh + Ismm + Isss;
      console.log("当前时间", nowData, this.LBName);
      this.ruleFormOutPut.jbDesc = this.LBName + nowData;
      console.log("当前时间的文件名", this.ruleFormOutPut.jbDesc);
    },
    // 取消导入
    closeOutPut() {
      (this.dataRange = 1),
        (this.namingRule = 1),
        (this.formatRule = 1),
        (this.countNum = 1);
      this.ruleFormOutPut = {
        checkAll: true, // 全选
        // checkAll: false, // 全选
        jbDesc: "",
        gzRadio: 1, // 数据范围
        fieldGroup: [], // 表头字段
      };
      this.fieldArr = [];
      this.ruleFormOutPut.checkAll = true;
      this.ruleFormOutPut.jbDesc = "";
      this.ruleFormOutPut.gzRadio = 1;
      this.ruleFormOutPut.fieldGroup = [];
      console.log("取消导入", this.ruleFormOutPut);
      this.isIndeterminate = false;
      this.total = 0;
      this.$emit("closeNewTask");
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      // if (validateMessage) {
      //   this.$message.error(validateMessage);
      // }
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    agreeNotice() {
      console.log(1111111);
      this.daochuTimer = null;
      this.downloadUrl = "";
      this.DaochuSuccese = {
        errorData: [], //错误数据  暂存前端 下载错误数据时返回
        Time: "导出中", //耗时
      };
      this.percenNum = 0;
      this.daochuGuoCModal = false;
      this.guanbiDisabled = true;
      this.noticeModal = false;
      this.daochu();
    },
    // 关闭弹窗
    closeNotice() {
      this.noticeModal = false;
    },
    downExcel() {
      console.log(111);
      this.downloadFile(this.downloadUrl);
    },
    async isNoFoundUser() {
      this.loading = true;
      try {
        const parms = {
          tenantId: this.userInfo.tenant_id,
          identity: this.identity,
          fileName: `没有${this.choiceNameRule}的${this.yHu}`,
          dataRange: this.dataRange, //需要导出的数据范围  1全部数据,2条件检索,3勾选数据
          namingRule: this.namingRule,
          formatRule: this.formatRule,
          formInline: this.formInline, //检索条件
          choiceDataIds: this.checkID, //id集合
        };
        let {
          data: { status, msg, result },
        } = await this.$store.dispatch("checkExportImg", parms);
        if (status != 1000) {
          this.$message({
            type: "error",
            message: msg,
          });
        } else {
          console.log(result);
          const index = result.redisKey.lastIndexOf(":process");
          const isDownExcel = result.redisKey.substring(1, index);
          console.log(isDownExcel);
          (this.noitceContent = ""), // 提示信息
            (this.noticeSpec = ""), // 标红提示
            (this.noticeModal = true);
          this.agreeContent = "继续导出";
          this.redisKey = result.redisKey;
          this.getTime("/api/blade-platform/userImg/excel/checkExportImg");
        }
      } catch (err) {
        console.log(err);
      }
    },
    //导出数据
    daochu() {
      try {
        this.countNum = 0;
        this.$refs.ruleFormOut.validate((valid) => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            const url = this.daochuURL;
            console.log("urlllll", url);
            let params = {
              tenantId: this.userInfo.tenant_id,
              identity: this.identity,
              fileName: this.ruleFormOutPut.jbDesc,
              dataRange: this.dataRange, //需要导出的数据范围  1全部数据,2条件检索,3勾选数据
              namingRule: this.namingRule,
              formatRule: this.formatRule,
              formInline: this.formInline, //检索条件
              choiceDataIds: this.checkID, //id集合
            };
            console.log("看看params", params);
            daochuSelectBTPost(url, params).then((res) => {
              console.log("看一看拿到了什么", res);
              const data = res.data;
              if (data.status == 1000) {
                console.log(1);
                this.redisKey = data.result.redisKey;
                this.closeOutPut();
                this.daochuGuoCModal = true;
                clearInterval(this.daochuTimer);
                this.daochuTimer = null;
                this.IsDaochuTimes = 0;
                //开启定时器
                this.getTime();
              } else if (data.status === 1002) {
                this.$message.error(data.msg);
                this.closeOutPut();
                //清空定时器
                clearInterval(this.daochuTimer);
                this.daochuTimer = null;
                this.IsDaochuTimes = 0;
              } else {
                // debugger
                this.guanbiDisabled = false;
                this.$message.error(data.msg);
              }
            });
            this.daochuGuoCModal = true;
            this.closeOutPut();
          } else {
            return false;
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //查询导出状况定时器
    getTime(curl) {
      this.daochuTimer = setInterval(() => {
        this.IsDaochuTimes = this.IsDaochuTimes + 3;
        this.daoruIng(curl);
      }, 3000);
    },
    //轮询状态请求查询导出状况
    daoruIng(curl) {
      // debugger
      const _this = this;
      try {
        const url = curl ? curl : this.lunxun;
        console.log("urlllll", url);
        let params = {};
        params = {
          tenantId: this.userInfo.tenant_id,
          redisKey: this.redisKey,
        };
        toDaoRuData(url, params).then((res) => {
          const data = res.data;
          console.log("这是轮询状态请求查询导出状况接口", data);
          if (data.status === 1000) {
            // 没有结果的情况
            if (data.result === "null") {
              return;
            }
            // 没有完成导出的情况
            let asyncTask = data.result;
            this.percenNum = new Number( //finishRate:真实进度
              (asyncTask.finishRate * 100).toFixed(2)
            );
            this.DaochuSuccese = Object.assign(this.DaochuSuccese, asyncTask);
            // 没有结束的时候 时间需要手动计算
            // this.DaochuSuccese.Time = ((new Date() - new Date(asyncTask.startTime))/1000).toFixed(2)
            if (asyncTask.useTimeStr) {
              this.DaochuSuccese.Time = asyncTask.useTimeStr;
            }
            if (asyncTask.finished == true) {
              clearInterval(this.daochuTimer);
              this.daochuTimer = null;
              if (curl) {
                console.log(data.result);
                // debugger
                this.loading = false;
                if (!data.result.result) {
                  this.$message.error(data.result.errorMsg)
                  this.noticeModal = false;
                  console.log(1111111);
                  this.daochuTimer = null;
                  this.downloadUrl = "";
                  this.DaochuSuccese = {
                    errorData: [], //错误数据  暂存前端 下载错误数据时返回
                    Time: "导出中", //耗时
                  };
                  this.percenNum = 0;
                  this.daochuGuoCModal = false;
                  this.guanbiDisabled = true;
                  return;
                } else if (data.result.result.url) {
                  this.downloadUrl = data.result.result.url;
                  return;
                } else {
                  //  this.daoru();
                  this.noticeModal = false;
                  console.log(1111111);
                  this.daochuTimer = null;
                  this.downloadUrl = "";
                  this.DaochuSuccese = {
                    errorData: [], //错误数据  暂存前端 下载错误数据时返回
                    Time: "导出中", //耗时
                  };
                  this.percenNum = 0;
                  this.daochuGuoCModal = false;
                  this.guanbiDisabled = true;
                  _this.daochu();
                  return;
                }
              }
              // this.DaochuSuccese.Time = asyncTask.useTime;
              console.log("DaochuSuccese", this.DaochuSuccese);
              this.IsDaochuTimes = 0;
              this.percenNum = 100;
              this.guanbiDisabled = false;
              this.isTS = "导出完成";
              if (asyncTask.result.url) {
                this.downloadUrl = asyncTask.result.url;
                this.downloadFile(asyncTask.result.url);
              }
              if (this.isTS !== "导出完成") {
                this.$message.error(this.isTS);
              } else if (asyncTask.errorMsg) {
                this.$message.error("操作失败");
              } else {
                this.$message.success(this.isTS);
              }
            }
          } else if (data.status === 8010) {
            // 网络超时终端，不进行处理
            return;
          } else {
            this.daochuTitle = "导出失败";
            console.error("导出情况获取失败 导出数据：" + JSON.stringify(data));
            clearInterval(this.daochuTimer);
            this.daochuTimer = null;
            this.isTS = "操作失败";
            if (this.isTS !== "导出完成") {
              this.$message.error(this.isTS);
            } else {
              this.$message.success(this.isTS);
            }
            this.guanbiDisabled = false;
            // this.isdaochuGuoC();
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    downloadFile(url) {
      const a = document.createElement("a");
      a.href = url;
      a.download = decodeURIComponent(this.ruleFormOutPut.jbDesc);
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
      // this.outputModal = false
    },
    //下载文件
    download(data, fileName, fileType) {
      if (!data) {
        return;
      }
      var blob = new Blob([data], {
        type: fileType ? fileType : "application/vnd.ms-excel",
      });
      var url = window.URL.createObjectURL(blob);
      var aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.href = url;
      aLink.setAttribute(
        "download",
        fileName ? fileName : new Date().getTime()
      );
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink); //下载完成移除元素
      window.URL.revokeObjectURL(url); //释放掉blob对象
    },
    //获取导出数据总条数
    selectTotal() {
      try {
        const url = this.ExportCountURL;
        console.log("urlllllllll", url);
        let params = {
          tenantId: this.userInfo.tenant_id,
          identity: this.identity,
          fileName: this.ruleFormOutPut.jbDesc,
          dataRange: this.dataRange, //需要导出的数据范围  1全部数据,2条件检索,3勾选数据
          namingRule: this.namingRule,
          formatRule: this.formatRule,
          formInline: this.formInline, //检索条件
          choiceDataIds: this.checkID, //id集合
        };
        daochuSelectBTPost(url, params).then((res) => {
          console.log("看一看拿到了什么", res);
          const data = res.data;
          if (data.status == 1000) {
            this.total = data.result;
            console.log("现在的总条数", this.total);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //点击更换导出数据范围
    chickRadio(val) {
      if (val == 3) {
        if (this.checkID == "") {
          this.total = 0;
        } else {
          let chickIdArr = this.checkID.split(",");
          this.total = chickIdArr.length;
          console.log("看看勾选ID长度", chickIdArr);
        }
      } else {
        console.log("点击数据范围");
        this.selectTotal();
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    choiceNameRule() {
      console.log(this.namingRule);
      if (this.namingRule == 1) {
        return "考生号";
      } else if (this.namingRule == 2 && this.identity == 'TEACHER') {
        return "工号";
      } else if (this.namingRule == 2 && this.identity == 'OTHER') {
        return "账号";
      } else if (this.namingRule == 2) {
        return "学号";
      } else {
        return "证件号码";
      }
    },
    yHu() {
      console.log(this.identity);
      if (this.identity == "NEW_STUDENT") {
        return "新生";
      } else if (this.identity == "STUDENT") {
        return "在校生";
      } else if (this.identity == "GRADUATE_STUDENT") {
        return "毕业生";
      } else if (this.identity == "TEACHER") {
        return "教工";
      } else if (this.identity == "OTHER") {
        return "其他用户";
      } else {
        return "用户";
      }
    },
  },
  mounted() {
    // if(this.currentChooseData!==0) {
    //   this.ruleFormOutPut.gzRadio = this.currentChooseData
    // }
  },
};
</script>

<style lang="scss">
.msgCard {
  .el-message-box__message {
    p {
      word-break: break-all;
    }
  }
}
.pullOut {
  .new-task-modal .el-dialog__body .el-form-item {
    display: block;
  }
  .daoru-addnew {
    height: 28px;
    line-height: 28px;
    margin-top: 16px;
    span {
      margin-right: 8px;
    }
  }
  .daoru-progress {
    .el-progress-bar {
      padding-right: 65px;
      margin-right: -65px;
    }
  }
  .errorMsg {
    color: rgb(255, 77, 79);
    font-size: 12px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .daoru-caozuoshuju {
    height: 12px;
    line-height: 12px;
    font-size: 12px;
    color: #aeaeb4;
    span {
      margin-right: 8px;
    }
  }
}
</style>
